import { jsPDF } from "jspdf";

export default function genPDF({
  datosfactura,
  detallefactura,
  isCredito,
  TextoNumber,
  sum1,
  sum2,
  impx,
  impy,
}) {
  const doc = new jsPDF({
    unit: "px",
    orientation: "landscape",
    format: "A4",
  });

  // ✅ Función para formatear miles
  const formatMiles = (num) => {
    if (num === undefined || num === null || num === "") return "";
    return Number(num).toLocaleString("es-PY");
  };

  // ✅ Valores nulos o faltantes
  datosfactura.direccion = datosfactura.direccion || "";
  datosfactura.telefono = datosfactura.telefono || "";
  datosfactura.iva5 = datosfactura.iva5 ?? datosfactura.gravado05;
  datosfactura.iva10 = datosfactura.iva10 ?? datosfactura.gravado10;
  datosfactura.totalmonto = datosfactura.totalmonto ?? datosfactura.totalFactura;
  datosfactura.ivatotal =
    datosfactura.ivatotal ??
    Number(datosfactura.gravado05 + datosfactura.gravado10);
  datosfactura.Subtotal5 = datosfactura.Subtotal5 ?? sum1;
  datosfactura.Subtotal10 = datosfactura.Subtotal10 ?? sum2;
  datosfactura.fechafactura =
    datosfactura.fechafactura ?? new Date().toLocaleDateString();

  const writePage = (offsetX = 0, offsetY = 0) => {
    let gapRow = 20;
    let isContado = isCredito;
    let casillaX = offsetX + 265 + (isContado ? 27 : 0);

    doc.setFont(undefined, "bold");
    doc.setFontSize(8);
    doc.text("X", casillaX + 6, offsetY + 59);

    doc.setFontSize(7);
    doc.setFont(undefined, "normal");

    // ✅ Datos del encabezado
    doc.text(datosfactura.fechafactura, offsetX + 58, offsetY + 59);
    doc.text(datosfactura.razonsocial, offsetX + 71, offsetY + 68);
    doc.text(datosfactura.ruc, offsetX + 55, offsetY + 76);
    doc.text(datosfactura.direccion, offsetX + 140, offsetY + 76);
    doc.text(datosfactura.telefono, offsetX + 264, offsetY + 76);

    // ✅ Ítems del detalle
    for (const [index, obj] of detallefactura.entries()) {
      addRow(obj, offsetX - 1, offsetY + 98 + index * gapRow);
    }

    // ✅ Subtotales y totales formateados
    doc.text(formatMiles(datosfactura.Subtotal5), offsetX + 230, offsetY + 406);
    doc.text(formatMiles(datosfactura.Subtotal10), offsetX + 270, offsetY + 406);

    doc.text(TextoNumber, offsetX + 72, offsetY + 413, { maxWidth: 180 });
    doc.text(formatMiles(datosfactura.totalmonto), offsetX + 269, offsetY + 416);

    doc.text(formatMiles(datosfactura.iva5), offsetX + 100, offsetY + 434);
    doc.text(formatMiles(datosfactura.iva10), offsetX + 167, offsetY + 434);
    doc.text(formatMiles(datosfactura.ivatotal), offsetX + 240, offsetY + 434);
  };

  // ✅ Fila del detalle
  const addRow = (data, x = 0, y) => {
    doc.setFont(undefined, "bold");
    doc.setFontSize(8);
    doc.text(String(data.cantidad), x + 18, y);
    doc.text(String(data.artcod), x + 42, y);

    doc.setFont(undefined, "normal");
    doc.setFontSize(8);
    doc.text(data.producto, x + 66, y, { maxWidth: 70 });

    // ✅ Valores formateados con separador de miles
    doc.text(formatMiles(data.precio), x + 170, y);
    doc.text(formatMiles(data.exenta), x + 203, y);
    doc.text(formatMiles(data.cinco), x + 233, y);
    doc.text(formatMiles(data.diez), x + 267, y);
  };

  // ✅ Imprime dos copias
  writePage(impx + 14, impy + 1);
  writePage(340 + impx, impy + 1);

  doc.autoPrint();
  doc.output("dataurlnewwindow");
}